// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isWithinRefs(refs: React.RefObject<HTMLDivElement[]>, e: any): boolean {
    let found = false;
    if (e?.target?.nodeType) {
        refs?.current?.forEach((current) => {
            if (current?.contains(e.target)) {
                found = true;
                return true;
            }
        });
    }
    return found;
}
